import React, { useState } from 'react';
import { IImageGalleryProps } from './types';
import {
  ImageContainer,
  UploadProgress,
  AddButton,
} from './ImageGallery.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MediaUpload from '../mediaUpload';
import { Image } from './image';

const ImageGallery: React.FC<IImageGalleryProps> = ({
  images,
  selectedIndex,
  allowAdd,
  onSelect,
  onAdd,
  onUpload,
  onDelete,
}) => {
  const [uploadProgress, setUploadProgress] = useState<number>(-1);

  const renderAddButtonBody = () => (
    <div className="text-center">
      <FontAwesomeIcon icon={['far', 'plus-circle']} size="3x" />
      <div>
        <small>Add Welcome Page</small>
      </div>
    </div>
  );

  return (
    <div>
      <div className="d-flex flex-wrap">
        {images.map((url: string, index: number) => (
          <ImageContainer key={index} selected={index === selectedIndex}>
            <Image
              id={`wi${index}`}
              url={url}
              selected={selectedIndex === index}
              allowDelete={images.length > 1}
              onSelect={() => onSelect(index)}
              onUpload={onUpload}
              onDelete={onDelete}
            />
          </ImageContainer>
        ))}
        {onAdd && (
          <AddButton role="button">
            {allowAdd ? (
              <>
                <MediaUpload
                  id="add-image"
                  url="/api/themes/welcomePageImage"
                  onChange={(field, mediaId) => {
                    onAdd(mediaId);
                    setUploadProgress(-1);
                  }}
                  onUploadProgress={setUploadProgress}
                >
                  {renderAddButtonBody()}
                </MediaUpload>
                <UploadProgress progress={uploadProgress} />
              </>
            ) : (
              renderAddButtonBody()
            )}
          </AddButton>
        )}
      </div>
    </div>
  );
};

export default ImageGallery;
